import { ReactNode } from 'react';
import { Box, Container, ContainerProps, Stack } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import { MobileHeader } from 'components/Layout/Header/MobileHeader';
import { colors } from 'styles/theme/colors';
import { Breadcrumb } from 'generated/graphql';
import { WebshopDesktopHeader } from 'components/Layout/components/WebshopDesktopHeader';
import Footer from '../Footer/Footer';
import Header from '../Layout/Header/Header';

type ProfileLayoutProps = {
    children: ReactNode;
    backgroundImageSrc: string;
    showBreadcrumbs?: true;
    breadcrumbs?: Breadcrumb[];
    sx?: SxProps;
    containerProps?: ContainerProps;
};

export function ProfileLayout({
    children,
    backgroundImageSrc,
    sx,
    containerProps = {},
}: ProfileLayoutProps) {
    return (
        <Stack sx={{ minHeight: '100svh' }}>
            <Header
                desktopHeader={() => (
                    <WebshopDesktopHeader />
                )}
                mobileHeader={(isOpen, toggleDrawer) => (
                    <MobileHeader
                        isOpen={isOpen}
                        toggleDrawer={toggleDrawer}
                    />
                )}
                breakpoint="lg"
            />
            <Box
                sx={{
                    width: '100%',
                    height: '300px',
                    borderBottom: `32px solid ${colors.corePink}`,
                    boxSizing: 'content-box',
                    backgroundImage: `url(${backgroundImageSrc})`,
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    ...sx,
                }}
            />
            <Container
                maxWidth={false}
                sx={{
                    maxWidth: '1175px',
                    paddingBottom: '64px',
                    paddingX: '25px',
                    flexGrow: 1,
                }}
                {...containerProps}
            >
                {children}
            </Container>
            <Footer />
        </Stack>
    );
}
